/**
 * @Author: zpc
 * @Description:
 * @DateTime: Created in 2021-11-17 13:37
 */

 import EnumItem, {enumMixn} from "./enumItem";

 /**
  * 播放类型
  */
 let EnmuEzopenType = {
     "预览": 						new EnumItem('预览', 1),
     "本地录像回放": 						new EnumItem('本地录像回放', 2),
     "云存储录像回放": 						new EnumItem('云存储录像回放', 3),
     ...enumMixn
 }
 export default EnmuEzopenType
 